import { slateJsonToPlainText } from "../../../../helpers/CommonUtility.jsx";
import "../../styles/styles.css";

const InstructionStack = ({ instructions = [], isCollapsed, onToggle }) => {
  const isEmpty = instructions.length === 0;

  const containerStyle = {
    height: "100%",
    width: "100%",
    overflowY: "auto",
    fontSize: "13px",
    fontFamily: "Segoe UI",
    color: "#4F4444",
    padding: "0 5px",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    transition: "height 0.2s ease-in-out",
  };

  if (isCollapsed) {
    containerStyle.height = "16px";
    containerStyle.overflowY = "hidden";
    containerStyle.alignItems = "center";
  }

  return (
    <div className="instruction-history-content" style={containerStyle}>
      <div style={{ flex: 1, overflowY: "auto", whiteSpace: "normal" }}>
        {isCollapsed ? (
          <p style={{ margin: 0, color: "#666", fontStyle: "italic" }}>...</p>
        ) : isEmpty ? (
          <p style={{ margin: 0, color: "#666", fontStyle: "italic" }}>
            History of your inputs
          </p>
        ) : (
          !isCollapsed &&
          instructions.map((inst, idx) => (
            <div
              key={idx}
              style={{
                borderBottom:
                  idx < instructions.length - 1 ? "1px solid #bcb7b7" : "none",
                paddingBottom: "4px",
                marginBottom: "4px",
              }}
            >
              <p
                style={{
                  fontWeight: inst.isNote ? "500" : "normal",
                  fontStyle: inst.isNote ? "italic" : "normal",
                  margin: "0",
                  whiteSpace: "pre-wrap",
                  color: inst.isNote ? "#888" : "#4F4444",
                }}
              >
                {slateJsonToPlainText(inst.prompt)}
              </p>
            </div>
          ))
        )}
      </div>
      <button
        onClick={onToggle}
        style={{
          backgroundColor: "transparent",
          border: "none",
          borderRadius: "4px",
          color: "white",
          padding: "2px 8px",
          cursor: "pointer",
          fontSize: "12px",
          marginLeft: "10px",
          alignSelf: "flex-start",
          marginRight: "3px",
          transform: isCollapsed ? "none" : "rotate(180deg)",
        }}
      >
        <svg
          width="13px"
          height="13px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 15.5L12 8.5L19 15.5"
            stroke="#130F26"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </button>
    </div>
  );
};

export default InstructionStack;
